module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "resetPasswordModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n      BIOveikals: Paroles atjaunošana\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui middle aligned grid"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.storeStatus.error != '') ? _c('div', {
    staticClass: "ui negative message"
  }, [_vm._v("\n            Pārbaudi e-pastu un paroli!\n          ")]) : _vm._e(), _vm._v(" "), (_vm.resetOk) ? _c('div', {
    staticClass: "ui positive message"
  }, [_vm._v("\n            Instrukcija par paroles atjaunošanu ir nosūtīta uz tavu e-pastu!\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui  center aligned  form"
  }, [_c('div', {
    staticClass: "ui  segment"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-pasts"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "ui fluid large custom_brown button",
    class: {
      loading: _vm.storeStatus.loading
    },
    attrs: {
      "disabled": _vm.credentials.email == ''
    },
    on: {
      "click": _vm.requestPasswordReset
    }
  }, [_vm._v("Atjaunot paroli")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6efbee7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordPage.vue
// module id = 358
// module chunks = 1